(()=>{
  'use strict';
  const root=document.querySelector('[data-nfc25-home]');
  if(!root)return;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const all=(sel,scope=root)=>Array.from(scope.querySelectorAll(sel));
  const lab=root.querySelector('[data-nfc25-tabs]');
  const controls=lab?all('[data-nfc25-tab]',lab):[];
  const photo=root.querySelector('[data-nfc25-lab-image]');
  const photoWrap=photo?.closest('.nfc25-lab-photo');
  const result=root.querySelector('#nfc25-lab-panel');
  const resultName=root.querySelector('[data-nfc25-lab-name]');
  const resultDescription=root.querySelector('[data-nfc25-lab-description]');
  const phoneTitle=root.querySelector('[data-nfc25-phone-title]');
  const matchLink=root.querySelector('[data-nfc25-lab-link]');
  let changeTimer=0;
  const activate=(button,focus=false)=>{
    if(!button)return;
    controls.forEach(el=>{
      const active=el===button;
      el.classList.toggle('is-active',active);
      el.setAttribute('aria-selected',String(active));
      el.setAttribute('tabindex',active?'0':'-1');
    });
    if(result)result.setAttribute('aria-labelledby',button.id);
    if(resultName)resultName.textContent=button.dataset.name||'';
    if(resultDescription)resultDescription.textContent=button.dataset.description||'';
    if(phoneTitle)phoneTitle.textContent=button.dataset.screen||'';
    if(matchLink)matchLink.href=button.dataset.link||'/collections/all';
    if(photo){
      clearTimeout(changeTimer);
      if(!reduced)photoWrap?.classList.add('is-changing');
      const setImage=()=>{photo.src=button.dataset.img||photo.src;photo.alt='Illustrative '+(button.dataset.name||'NFC')+' product shown in a business environment';photoWrap?.classList.remove('is-changing')};
      if(reduced)setImage();else changeTimer=setTimeout(setImage,110);
    }
    if(focus)button.focus();
  };
  controls.forEach((button,index)=>{
    button.addEventListener('click',()=>activate(button));
    button.addEventListener('keydown',event=>{
      if(!['ArrowRight','ArrowLeft','Home','End'].includes(event.key))return;
      event.preventDefault();
      let next=index;
      if(event.key==='ArrowRight')next=(index+1)%controls.length;
      if(event.key==='ArrowLeft')next=(index-1+controls.length)%controls.length;
      if(event.key==='Home')next=0;
      if(event.key==='End')next=controls.length-1;
      activate(controls[next],true);
    });
  });
  const stage=root.querySelector('[data-nfc25-tilt]');
  if(stage&&!reduced&&window.matchMedia('(pointer:fine)').matches){
    const move=event=>{
      const rect=stage.getBoundingClientRect();
      const x=((event.clientX-rect.left)/rect.width-.5)*2;
      const y=((event.clientY-rect.top)/rect.height-.5)*2;
      stage.style.setProperty('--tilt-x',(-y*3).toFixed(2)+'deg');
      stage.style.setProperty('--tilt-y',(x*4).toFixed(2)+'deg');
    };
    stage.addEventListener('pointermove',move,{passive:true});
    stage.addEventListener('pointerleave',()=>{stage.style.setProperty('--tilt-x','0deg');stage.style.setProperty('--tilt-y','0deg')});
  }
  if(!reduced&&'IntersectionObserver'in window){
    const revealNodes=all('[data-nfc25-reveal]');
    const visible=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');visible.unobserve(entry.target)}});
    },{rootMargin:'0px 0px 65px 0px',threshold:.08});
    requestAnimationFrame(()=>{root.classList.add('nfc25-motion-ready');revealNodes.forEach(el=>{if(el.getBoundingClientRect().top<window.innerHeight*1.05)el.classList.add('is-visible');else visible.observe(el)})});
  }
})();
